import React from "react"
import {useNavigate, useParams} from "react-router-dom"
import {useConfig} from "../../hooks/useConfig"
import {useParticipant} from "../../hooks/useParticipant"
import {useBoothSession} from "../../hooks/useBoothSession"
import SplashView from "../views/SplashView"
import Participant from "../../library/Participant"

function SplashPage() {
  const params = useParams<"code">()
  const code = params.code!
  const navigate = useNavigate()

  const {config, loading} = useConfig(code)
  const {participant, setParticipant} = useParticipant(config?.presetCode ?? code)
  const {clearImages} = useBoothSession(config?.presetCode ?? code)

  if (loading || !config) {
    return null
  }

  const handleEnter = (newParticipant: Participant) => {
    clearImages()
    setParticipant(newParticipant)
    navigate(`/${config.presetCode}/camera`)
  }

  return (
    <SplashView
      config={config}
      currentParticipant={participant}
      handleEnter={handleEnter}
    />
  )
}

export default SplashPage